var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#373C43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00977 15.4492C1.35156 15.7812 1.91797 15.7812 2.25 15.4492L8.5 9.19922L14.75 15.4492C15.082 15.7812 15.6582 15.791 15.9902 15.4492C16.3223 15.1074 16.3223 14.5508 15.9902 14.2188L9.74023 7.95898L15.9902 1.70898C16.3223 1.37695 16.332 0.810547 15.9902 0.478516C15.6484 0.136719 15.082 0.136719 14.75 0.478516L8.5 6.72852L2.25 0.478516C1.91797 0.136719 1.3418 0.126953 1.00977 0.478516C0.677734 0.820312 0.677734 1.37695 1.00977 1.70898L7.25977 7.95898L1.00977 14.2188C0.677734 14.5508 0.667969 15.1172 1.00977 15.4492Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a25a59901066a169d68d9e55a57b39de.svg";
export { ForwardRef as ReactComponent };